const apiURLs = {
  // if deploying to production, use this one
  production: "https://api-staging.webwotc.com",
  // if deploying to staging, use this one
  // production: "https://api-staging.webwotc.com",
  staging: "https://api-staging.webwotc.com",
  development: "https://api-staging.webwotc.com",
};

export default {
  // eventually we will have environment variable support, but I am not sure
  // when that will be
  // apiURL: process.env.API_URL || apiURLs.development,
  apiURL: apiURLs[process.env.NODE_ENV],
};



// WEBPACK FOOTER //
// ./src/Config.js